<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="活动名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入活动名称" :maxLength="20"/>
      </a-form-model-item>
      <a-form-model-item label="活动文案" prop="copyText" >
        <a-input v-model="form.copyText" placeholder="请输入活动文案" type="textarea" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="活动主图" prop="mainImage">
        <oss-multi-upload-single v-model="form.mainImage" type="img" :maxSize="10"></oss-multi-upload-single>
      </a-form-model-item>
      <a-form-model-item label="活动详情图" prop="detailImages">
        <oss-multi-upload v-model="form.detailImages" type="img" bucket="activity" :maxSize="10" :maxCount="10"></oss-multi-upload>
      </a-form-model-item>
      <a-form-model-item label="活动开始时间" prop="startTime">
        <a-date-picker
          style="width: 100%"
          @change="onDateChange"
          v-model="form.startTime"
          :showTime="true"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="活动结束时间" prop="endTime">
        <a-date-picker
          style="width: 100%"
          @change="onDateChange1"
          v-model="form.endTime"
          :showTime="true"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="跳转页面" prop="toPage" >
        <a-input v-model="form.toPage" placeholder="请输入跳转页面" :maxLength="200"/>
      </a-form-model-item>
      <a-form-model-item label="上架状态" prop="putawayStatus">
        <a-select v-model="form.putawayStatus" placeholder="请选择上架状态" allow-clear>
          <a-select-option :value="false">未上架</a-select-option>
          <a-select-option :value="true">已上架</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>

  </a-drawer>
</template>

<script>
import IndexScriptModal from '@/components/Script/IndexScriptModal.vue'
import OssMultiUpload from '@/views/script/script/modules/OssMultiUpload.vue'
import OssMultiUploadSingle from '@/views/script/script/modules/OssMultiUploadSingle.vue'
import { addRebateActivity, getRebateActivity, updateRebateActivity } from '@/api/played/rebateActivity'

export default {
  name: 'CreateSouvenirActivity',
  props: {
  },
  components: {
    OssMultiUploadSingle,
    OssMultiUpload,
    IndexScriptModal
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        type: 2,
        name: null,
        copyText: null,
        mainImage: null,
        detailImages: undefined,
        startTime: null,
        endTime: null,
        claimStartTime: this.getNowFormatDate(),
        claimEndTime: this.getNowFormatDate(),
        totalPool: 0,
        remainingPool: 0,
        status: null,
        putawayStatus: undefined,
        toPage: undefined
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: ['blur', 'change'] }
        ],
        copyText: [
          { required: true, message: '请输入活动文案', trigger: ['blur', 'change'] }
        ],
        mainImage: [
          { required: true, message: '请上传活动主图', trigger: ['blur', 'change'] }
        ],
        detailImages: [
          { required: true, message: '请上传活动详情图', trigger: ['blur', 'change'] }
        ],
        startTime: [
          { required: true, message: '请选择活动开始时间', trigger: ['blur', 'change'] }
        ],
        endTime: [
          { required: true, message: '请选择活动结束时间', trigger: ['blur', 'change'] }
        ],
        toPage: [
          { required: true, message: '请输入跳转页面', trigger: ['blur', 'change'] }
        ],
        putawayStatus: [
          { required: true, message: '请选择上架状态', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onDateChange(date, dateString) {
      this.form.startTime = dateString
    },
    onDateChange1(date, dateString) {
      this.form.endTime = dateString
    },
    onDateChange2(date, dateString) {
      this.form.claimStartTime = dateString
    },
    onDateChange3(date, dateString) {
      this.form.claimEndTime = dateString
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: 2,
        name: null,
        copyText: null,
        mainImage: null,
        detailImages: undefined,
        startTime: null,
        endTime: null,
        claimStartTime: this.getNowFormatDate(),
        claimEndTime: this.getNowFormatDate(),
        totalPool: 0,
        remainingPool: 0,
        status: null,
        putawayStatus: undefined,
        toPage: undefined
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增伴手礼活动'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRebateActivity(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改伴手礼活动'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRebateActivity(this.form).then(() => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRebateActivity(this.form).then(() => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    getNowFormatDate() {
      const date = new Date()

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')

      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>
